import { ClientWrapper } from './client/client';
import { RfidWrapper } from './rfid/rfid';
import { EpmWrapper } from './epm/epm';
import { PlatesWrapper } from './plates/plates';
import { SubscriptionWrapper } from './subscription/subscription';
import { ZonesLimit } from './zones-limit/zones-limit';
import { LK } from './lk/lk';
import { Counters } from './counters/counters';
import { Content } from './client-tabs-content.styled';

export const ClientTabsContent = (props) => {
  const { tab, client, ...rest } = props;

  const params = {
    client,
    clientId: client.id,
    ...rest,
  };

  return (
    <Content tab={tab}>
      {tab === 'data' && <ClientWrapper {...params} />}
      {tab === 'rfid' && <RfidWrapper {...params} />}
      {tab === 'epm' && <EpmWrapper {...params} />}
      {tab === 'plates' && <PlatesWrapper {...params} />}
      {tab === 'subscription' && <SubscriptionWrapper {...params} />}
      {tab === 'zoneslimit' && <ZonesLimit {...params} />}
      {tab === 'lk' && <LK {...params} />}
      {tab === 'counters' && <Counters {...params} />}
    </Content>
  );
};
